import { Box } from '..'

export const Switch = ({ checked, onChange }) => (
  <Box
    container
    height={24}
    width={40}
    alignItems="center"
    r={12}
    p={3}
    onClick={() => onChange(!checked)}
    background={checked ? 'var(--blue)' : 'var(--red)'}
    transition="all 0.25s"
  >
    <Box
      height={18}
      width={18}
      r={9}
      left={checked ? 16 : 0}
      background={checked ? 'white' : 'black'}
      position="relative"
      transition="all 0.25s"
    />
  </Box>
)